import type { FaireProductEntity } from "../../entity_types/product";

export const p_x93v8xds46: FaireProductEntity = {
  token: "p_x93v8xds46",
  type: "product",
  name: "Girls Baseball Hat- Ditsy Floral- Mauve (2-6/7Y)",
  brandToken: "b_2eu7jxi2",
  brandName: "Peppercorn Kids",
  imageUrl: "https://cdn.faire.com/fastly/2fe1123435b18f3afebae8379f92ed0f8331859da3940d0c4b4b247f8404bbbd.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/564dcb6429464ec8b16c77916c6e754e0b8520a6eeea580b342c82977bb6fdda.png",
    "https://cdn.faire.com/fastly/3cb35617cf8ad8597d44a5469059f5ef58aa3bc50b914ceed79d3a4ab2ab68a9.png",
    "https://cdn.faire.com/fastly/53384858dcceb99fa3350a1abda945dde3481d01d9ffbf46294801133268b804.jpeg",
    "https://cdn.faire.com/fastly/20cff3e8fa1a361e964bd96c160ab2fa01e97e873095965dd199c7d4e5606a96.jpeg",
    "https://cdn.faire.com/fastly/ee8aa199a915bc67c44a3eb99428aee045a5325db7b7ff630455de9931a13c2b.jpeg"
  ],
  priceDollars: 10.5,
  description: "We love this slightly nostalgic floral print, in beautiful muted mauve pink. This cap has a lot of character, is versatile and travels through most seasons. \n\n100% Cotton \nSize: Fits kids ages toddler to about 7. \nHook and loop, Velcro like, adjustable closure\nHigh quality print and construction. \nSee more daisy related caps in our latest collection.\n\n",
  tags: [],
  msrpDollars: 21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:11.353Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
